import React, { memo, forwardRef, useContext, useRef } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@gwc/icons';
import { TextField } from '../text-field';
import { Popper } from '../popper';
import { List } from '../list';
import { Trails } from '../slots/Trail';
import { Box } from '../box';
import { ClearButton } from '../clear-button';
import { HiddenScroll } from '../hidden-scroll';
import { useSelect } from './useSelect';
import styles from './styles.module.css';
export const SelectContext = React.createContext(null);
export const Clear = memo(function Clear() {
    const context = useContext(SelectContext);
    if (!context) {
        throw new Error('Select.Clear has to be placed inside Select component');
    }
    const { state, value } = context;
    return (React.createElement(ClearButton, { hidden: Array.isArray(value) ? !value.length : !value, onPressStart: () => {
            state.selectionManager.clearSelection();
        } }));
});
export const Toggle = memo(function Toggle() {
    const context = useContext(SelectContext);
    const prevRefState = useRef({ prevOpenState: null });
    if (!context) {
        throw new Error('Select.Toggle has to be placed inside Select component');
    }
    const { state } = context;
    return (React.createElement(Trails.Icon, { onPointerDown: () => {
            // @ts-ignore
            prevRefState.current.prevOpenState = state.isOpen;
        }, onClick: e => {
            // Для избежания гонки. Когда popup открылся по фокусу
            if (prevRefState.current.prevOpenState === state.isOpen) {
                e.stopPropagation();
                state.toggle();
            }
        }, className: styles.toggle }, state.isOpen ? React.createElement(ChevronUpIcon, null) : React.createElement(ChevronDownIcon, null)));
});
export const Select = memo(forwardRef(function Select(props, ref) {
    const { children, value, variant } = props;
    const { textFieldProps, popperProps, listProps, inputProps: selectInputProps, labelProps: selectLabelProps, hiddenInputProps, state, } = useSelect(props, ref);
    return (React.createElement(SelectContext.Provider, { value: {
            state,
            value,
            variant,
        } },
        React.createElement(Box, { flexDirection: "column", flex: 1, className: styles.select },
            React.createElement(TextField, { ...textFieldProps }, ({ inputProps, labelProps, ...props }) => children({
                ...props,
                inputProps: {
                    ...selectInputProps,
                    ...inputProps,
                },
                labelProps: { ...selectLabelProps, ...labelProps },
                value,
            })),
            React.createElement("input", { ...hiddenInputProps, className: styles.hiddenInput, readOnly: true }),
            React.createElement(Popper, { ...popperProps },
                React.createElement(HiddenScroll, null, innerProps => (React.createElement(List, { ...{
                        ...listProps,
                        ...innerProps,
                    } })))))));
}));
